import type { SupportSuggestion } from "../types";

export const supportSuggestions: SupportSuggestion[] = [
  {
    title: "Written meeting agenda",
    barrier: "Unclear expectations",
    setup: "Ask for an agenda and intended decisions at least one working day ahead.",
    hypothesis: "Knowing the shape of the meeting will reduce preparation load."
  },
  {
    title: "Protected focus block",
    barrier: "Focus & interruption",
    setup: "Reserve a recurring block with notifications paused and a visible focus status.",
    hypothesis: "Fewer context switches will make complex work more sustainable."
  },
  {
    title: "Captioned calls",
    barrier: "Communication",
    setup: "Enable live captions by default and share written decisions after the call.",
    hypothesis: "A second communication channel will reduce missed details."
  },
  {
    title: "Quiet workspace option",
    barrier: "Sensory load",
    setup: "Use a low-traffic desk, quiet room, or remote option for concentrated work.",
    hypothesis: "Lower background input will preserve capacity for the task."
  },
  {
    title: "Flexible start window",
    barrier: "Energy & recovery",
    setup: "Trial a consistent 60-minute arrival window while keeping core collaboration hours.",
    hypothesis: "A small timing buffer will reduce symptom-related disruption."
  },
  {
    title: "Instructions in two formats",
    barrier: "Memory & processing",
    setup: "Pair verbal instructions with a short written checklist or example.",
    hypothesis: "A durable reference will reduce working-memory demand and rework."
  },
  {
    title: "Camera-optional meetings",
    barrier: "Sensory load",
    setup: "Keep cameras optional unless visual participation is essential to the task.",
    hypothesis: "Reducing visual self-monitoring will leave more capacity for discussion."
  },
  {
    title: "Recovery buffer",
    barrier: "Energy & recovery",
    setup: "Protect 15 minutes after high-demand meetings or travel before the next task.",
    hypothesis: "A deliberate transition will reduce cumulative overload."
  },
  {
    title: "One clear priority",
    barrier: "Unclear expectations",
    setup: "At the start of the day, agree which outcome takes priority if time becomes limited.",
    hypothesis: "Explicit trade-offs will reduce uncertainty and stalled decisions."
  },
  {
    title: "Longer response window",
    barrier: "Time & pacing",
    setup: "Mark non-urgent questions clearly and allow an asynchronous response.",
    hypothesis: "More processing time will improve accuracy without blocking others."
  },
  {
    title: "Accessible workstation check",
    barrier: "Physical access",
    setup: "Review reach, seating, input devices, routes, and rest positions with the person using them.",
    hypothesis: "Small physical changes will reduce strain across the day."
  },
  {
    title: "Meeting role clarity",
    barrier: "Communication",
    setup: "State the facilitator, note-taker, decision owner, and expected contribution.",
    hypothesis: "Clear participation cues will make discussion easier to navigate."
  }
];
